import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Home() {
  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <h1 className="company-name">Tran Tech Solutions LLC</h1>
          <p className="tagline">Empowering Property Management Through Smart Technology</p>
        </div>
      </header>

      <main className="main">
        <div className="container">
          <section className="hero">
            <h2 className="product-name">At Home Laundromat</h2>
            <p className="product-subtitle">The Comprehensive Smart Laundry Management Platform for Modern Residential Properties</p>
          </section>

          <section className="product-overview">
            <div className="overview-content">
              <h3>Maximize Property Value While Enhancing Tenant Satisfaction</h3>
              <p>
                At Home Laundromat is an enterprise-grade laundry management solution designed specifically for property owners and managers. Our platform transforms standard in-unit washers and dryers into intelligent, revenue-generating assets with comprehensive policy controls, real-time monitoring, and flexible usage management. Whether you manage a single property or an extensive portfolio, our solution delivers the tools you need to optimize operations, reduce costs, and create sustainable revenue streams from existing appliances.
              </p>
            </div>
          </section>

          <section className="features">
            <h3>Enterprise-Grade Features</h3>
            <div className="features-grid">
              <div className="feature-card">
                <h4>Dynamic Revenue Management</h4>
                <p>Implement sophisticated pricing strategies with customizable rate structures, promotional periods, and tiered usage models. Our flexible billing engine adapts to your business model, whether you prefer per-load charges, subscription plans, or hybrid approaches that maximize profitability while maintaining tenant satisfaction.</p>
              </div>

              <div className="feature-card">
                <h4>Intelligent Scheduling & Access Control</h4>
                <p>Optimize appliance utilization with granular time-based access policies. Define operational hours, implement quiet periods, and manage peak-time demand with automated scheduling that balances property needs with tenant convenience. Reduce noise complaints and extend equipment lifespan through strategic usage distribution.</p>
              </div>

              <div className="feature-card">
                <h4>Comprehensive Usage Analytics</h4>
                <p>Gain actionable insights with detailed consumption tracking and allocation management. Monitor individual tenant usage patterns, identify trends, and make data-driven decisions about policies and pricing. Configure complimentary usage quotas and promotional allowances that align with your property positioning.</p>
              </div>

              <div className="feature-card">
                <h4>Automated Policy Enforcement</h4>
                <p>Eliminate manual oversight with intelligent rule-based controls that automatically enforce your laundry policies. Prevent unauthorized access, manage abuse, and ensure fair usage across all tenants. Our system handles compliance seamlessly, freeing your staff to focus on higher-value activities.</p>
              </div>

              <div className="feature-card">
                <h4>Intuitive Multi-Platform Interface</h4>
                <p>Deliver exceptional user experiences for both property managers and tenants through our thoughtfully designed, responsive platform. Streamlined workflows reduce administrative burden while mobile-friendly tenant access ensures satisfaction and adoption. Cloud-based management provides anywhere, anytime control.</p>
              </div>

              <div className="feature-card">
                <h4>Advanced Business Intelligence</h4>
                <p>Transform operational data into strategic advantage with comprehensive reporting and analytics dashboards. Track revenue performance, monitor equipment utilization, forecast maintenance needs, and identify optimization opportunities. Export custom reports for accounting, strategic planning, and stakeholder communications.</p>
              </div>
            </div>
          </section>

          <section className="benefits">
            <h3>Measurable Value for Every Stakeholder</h3>
            <div className="benefits-content">
              <div className="benefit-column">
                <h4>Property Owners & Managers</h4>
                <ul>
                  <li>Create new recurring revenue streams from existing in-unit appliances without capital investment</li>
                  <li>Reduce operational expenses through intelligent utility consumption management and monitoring</li>
                  <li>Extend equipment lifespan and reduce maintenance costs by preventing misuse and abuse</li>
                  <li>Eliminate time-consuming manual policy enforcement and dispute resolution</li>
                  <li>Enhance property positioning with modern amenities that appeal to quality tenants</li>
                  <li>Improve operational efficiency with centralized management across multiple properties</li>
                  <li>Access detailed analytics for informed capital expenditure and strategic planning decisions</li>
                  <li>Demonstrate professional management standards that support premium rental rates</li>
                </ul>
              </div>

              <div className="benefit-column">
                <h4>Residents & Tenants</h4>
                <ul>
                  <li>Enjoy the premium convenience of private in-unit laundry facilities without leaving home</li>
                  <li>Experience transparent, predictable pricing with no hidden fees or surprises</li>
                  <li>Benefit from fair, consistently enforced usage policies that protect all residents</li>
                  <li>Access appliances according to clearly communicated schedules that respect community living</li>
                  <li>Receive responsive service from property management with reduced friction points</li>
                  <li>Utilize intuitive technology that simplifies laundry management and monitoring</li>
                  <li>Appreciate well-maintained equipment that reflects quality property management</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="cta">
            <h3>Transform Your Property Management Strategy Today</h3>
            <p>Discover how At Home Laundromat can enhance your property value, reduce operational costs, and create sustainable revenue streams. Our team is ready to discuss your specific requirements and demonstrate how our platform can be customized to meet your unique property management objectives.</p>
            <div className="contact-info">
              <p>Email: support@trantechus.com</p>
              <p>Phone: (650) 336-0577</p>
            </div>
          </section>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Tran Tech Solutions LLC. All rights reserved.</p>
          <p style={{ marginTop: '0.5rem' }}>
            <Link to="/privacy" style={{ color: 'white', textDecoration: 'underline' }}>Privacy Policy</Link>
            {' | '}
            <Link to="/account-deletion" style={{ color: 'white', textDecoration: 'underline' }}>Account Deletion</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Home;
